// Component rendering page title
// Tooltip to be shown if provided

import React from "react";
import { Skeleton } from "@mui/material";

import TooltipInfoComponent from "../tooltip-info/TooltipInfoComponent";
import ContentPopoverComponent from "../content-popover/ContentPopoverComponent";

const Title = (props) => {
  const {
    className = "",
    loading,
    title,
    tooltipText,
    titleClass = "",
  } = props;

  if (loading)
    return <Skeleton animation='wave' height={24} variant='rounded' />;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <p className={titleClass ? titleClass : "page-title"}>{title}</p>
      {tooltipText && (
        <TooltipInfoComponent
          content={<ContentPopoverComponent contentTitle={tooltipText} />}
          size='small'
        />
      )}
    </div>
  );
};

export default Title;
